import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import LoadingWrapper from 'components/LoadingWrapper';
import intl from 'i18n/intl';
import { isEmpty } from 'lodash';
import { useAppDispatch } from 'slices/store';
import { Button, DefaultContentLayout } from '@timeedit/ui-components';
import { Col, Form, Input, Row } from '@timeedit/ui-components/antd';
import {
  getWeekNames,
  updateWeekNames,
  weekNamesLoading,
  weekNamesSelector,
} from '../../../../slices/appsPrefWeekNames';
import './WeekNames.scss';

const language: any = intl.messages;

const WeekNames = () => {
  const [form] = Form.useForm();
  const dispatch = useAppDispatch();

  const weekNames = useSelector(weekNamesSelector);
  const isLoading = useSelector(weekNamesLoading);

  const [isEdited, setIsEdited] = useState(false);

  const onSubmit = (dataBody: any) => {
    if (dataBody) {
      const payload = [];
      for (const _id in dataBody) {
        payload.push({
          week: dataBody[_id],
        });
      }
      dispatch(updateWeekNames(payload));
    }
  };
  // Effect
  useEffect(() => {
    dispatch(getWeekNames());
  }, [dispatch]);

  useEffect(() => {
    if (!isEmpty(weekNames)) {
      const dataField: any = weekNames.reduce(
        (cal: any, { _id, week }: any) => {
          return {
            ...cal,
            [_id]: week,
          };
        },
        {}
      );
      form.setFieldsValue(dataField);
    }
  }, [weekNames, form]);

  return (
    <DefaultContentLayout
      title={language.preferences_settings}
      subtitle={language.week_name}
      actions={
        <Button type="primary" onClick={() => onSubmit(form.getFieldsValue())}>
          {language.save_changes as string}
        </Button>
      }
    >
      <div className="organization__week-names" style={{ padding: 15 }}>
        <Row gutter={16} style={{ marginBottom: 15 }}>
          <Col span={4}>
            <b>Calendar week</b>
          </Col>
          <Col span={20}>
            <b>Week name</b>
          </Col>
        </Row>
        <LoadingWrapper isLoading={isLoading}>
          <Form
            {...formItemLayout}
            form={form}
            onFieldsChange={() => {
              setIsEdited(true);
            }}
            onFinish={onSubmit}
          >
            {weekNames.map((weekName: any, index: number) => (
              <WeekRow key={weekName._id} value={weekName} weekIndex={index} />
            ))}
            <br />
          </Form>
        </LoadingWrapper>
      </div>
    </DefaultContentLayout>
  );
};

export default WeekNames;

// CONSTANTS
const formItemLayout = {
  labelCol: {
    span: 4,
  },
  wrapperCol: {
    span: 20,
  },
};

const WeekRow = ({ value, weekIndex }: any) => {
  return (
    <Form.Item
      name={value._id}
      label={`Week ${weekIndex + 1}`}
      rules={[{ required: true, message: ' ' }]}
    >
      <Input />
    </Form.Item>
  );
};
